import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { useGetConfig } from './ChatBot';
import { scaledFontSize } from './createWidgetTheme';
import { resolveQuickStartIntro } from '@/lib/quick-start-intro';
import { BotMessageHeading } from './_parts/BotMessageHeading';

export function WelcomeMessage() {
  const theme = useTheme();
  const config = useGetConfig();
  const shouldScaleTypography =
    ((theme as { widgetTypographyScale?: number }).widgetTypographyScale ?? 1) > 1;

  // Hooks must run unconditionally — keep them above any early returns.
  const mountTime = React.useMemo(
    () => new Date().toLocaleTimeString(),
    [],
  );

  // Prefer the BFF-resolved intro; fall back client-side in case an older
  // chat-config payload omits it.
  const introMessage = resolveQuickStartIntro(
    config.quickStartIntroMessage,
    config.institutionName,
  );

  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      py={0.5}
      sx={{ width: '100%', px: 2, mt: 2 }}
    >
      <Box sx={{ maxWidth: '80%' }}>
        <Paper
          elevation={1}
          sx={{
            px: 2,
            py: 1.25,
            borderRadius: 4,
            borderTopLeftRadius: 0,
            color: 'text.primary',
            bgcolor: 'common.white',
          }}
        >
          <BotMessageHeading agentName={config.agentName} />

          <Typography
            variant="subtitle2"
            component="div"
            fontWeight={300}
            fontSize={shouldScaleTypography ? scaledFontSize(theme, 14) : undefined}
            sx={{ lineHeight: 1.6, whiteSpace: 'pre-wrap' }}
          >
            {introMessage}
          </Typography>

          <Box display="flex" justifyContent="flex-end" alignItems="center" mt={1} gap={0.25}>
            <Typography
              component="p"
              variant="subtitle1"
              fontSize={scaledFontSize(theme, 10)}
              fontWeight={100}
              color="textDisabled"
            >
              {mountTime}
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
